import { Fetch } from '@app/models/fetch';
import { Budget } from '@app/models/budgets/budgets.model';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "@angular/router";
var BudgetService = /** @class */ (function () {
    function BudgetService(fetch, router, route) {
        this.fetch = fetch;
        this.router = router;
        this.route = route;
    }
    BudgetService.prototype.get = function (id, ws) {
        return this.fetch.getOne("/devices/" + ws.id + "/budgets", id).model(Budget);
    };
    BudgetService.prototype.getAll = function (ws) {
        return this.fetch.getAll("/devices/" + ws.id + "/budgets").models(Budget);
    };
    BudgetService.prototype.create = function (ws, budget) {
        return this.fetch.post("/devices/" + ws.id + "/budgets", budget);
    };
    BudgetService.prototype.update = function (ws, id, budget) {
        return this.fetch.patch("/devices/" + ws.id + "/budgets", id, budget);
    };
    BudgetService.prototype.delete = function (ws, id) {
        return this.fetch.delete("/devices/" + ws.id + "/budgets", id);
    };
    BudgetService.prototype.navigateToBudgetRange = function (budget, timezone) {
        var scale = this.getBudgetRangeScale(budget);
        var params = {};
        params.since = DateTime.local().setZone(timezone).startOf(scale).toISO();
        params.until = DateTime.local().setZone(timezone).endOf(scale).toISO();
        params.scale = scale;
        params.new = 'true';
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: params,
        });
    };
    BudgetService.prototype.getBudgetRangeScale = function (budget) {
        switch (budget.toLowerCase()) {
            case 'daily':
                return 'day';
            case 'weekly':
                return 'week';
            case 'monthly':
                return 'month';
            default:
                return 'day';
        }
    };
    BudgetService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BudgetService_Factory() { return new BudgetService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i2.ActivatedRoute)); }, token: BudgetService, providedIn: "root" });
    return BudgetService;
}());
export { BudgetService };
